/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './common';
import '../../../common/messages';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "precog": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "signals": {
                    "nested": {
                      "external": {
                        "nested": {
                          "FetchBySignalTypeRequest": {
                            "fields": {
                              "signalTypes": {
                                "type": ".squareup.precog.api.v2.signals.SignalType",
                                "id": 1,
                                "rule": "repeated"
                              }
                            }
                          },
                          "PrecogSignalExternalService": {
                            "methods": {
                              "Fetch": {
                                "requestType": ".squareup.common.messages.Empty",
                                "responseType": ".squareup.precog.api.v2.signals.FetchResponse"
                              },
                              "FetchBySignalType": {
                                "requestType": ".squareup.precog.api.v2.signals.external.FetchBySignalTypeRequest",
                                "responseType": ".squareup.precog.api.v2.signals.FetchResponse"
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.precog?.nested?.api?.nested?.v2?.nested?.signals?.nested?.external?.nested?.FetchBySignalTypeRequest && !$root.nested?.squareup?.nested?.precog?.nested?.api?.nested?.v2?.nested?.signals?.nested?.external?.nested?.PrecogSignalExternalService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE FetchBySignalTypeRequest @ squareup/precog/v2/signals/external.proto at 32:1
 */
export const FetchBySignalTypeRequest = $root.lookupType('squareup.precog.api.v2.signals.external.FetchBySignalTypeRequest');
fixType(FetchBySignalTypeRequest, {
  signalTypes: {
    required: true
  }
});
Builder.createAndAttachToType(FetchBySignalTypeRequest);
/**
 * SOURCE PrecogSignalExternalService @ squareup/precog/v2/signals/external.proto at 14:1
 */
export const PrecogSignalExternalService = $root.lookupService('squareup.precog.api.v2.signals.external.PrecogSignalExternalService');